import axios from 'axios'
import router from '@/router'

import { getToken,getUserInfo, delToken, delUserInfo } from '@/libs/utils'

class HttpRequest {
  constructor(baseUrl = baseUrl) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        fwebkitsn: 'bmc_fenpei',
        'content-type': 'application/x-www-form-urlencoded',
        token: getToken()||'',
      },
    }
    return config
  }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        console.log(getUserInfo())
        console.log(getToken())
        // if(!getUserInfo() || !getToken()){
        //   delToken()
        //   delUserInfo()
        //   router.push({
        //     name: 'index',
        //     query:{
        //       _time:new Date().getTime()/1000 
        //     }
        //   })
        // }
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
         console.log(res.data.map.result)
        if (res.data.map.result == '-9004') {
          router.replace({ name: 'Error', params: { info: "授权登录出错，请确认是否绑定企业微信！" } })
        }
        if (res.data.map.result == '-10009' ) {
          router.replace({ name: 'Error', params: { info: "无权限！" } })
        }
        if (res.data.map.result == '-10003' ) {
          delToken()
          delUserInfo()
          router.push({
            path: '/',
          })
        }
        if (res.data.map.result != '1') {
          Promise.reject(res.data.map)
        }


        this.destroy(url)
        const { data, status } = res
        return { data, status }
      },
      (error) => {
        this.destroy(url)
        return Promise.reject(error)
      }
    )
  }
  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest